import { FACEBOOK_PAGE_URL } from '../constants/facebook';
import { trackFacebookFollowClick } from '../ga';
import './FacebookFollowLink.css';

function FacebookIcon({ size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="facebook-follow-link__icon"
    >
      <path
        fill="currentColor"
        d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
      />
    </svg>
  );
}

/**
 * @param {{
 *   location: string;
 *   variant?: 'button' | 'text' | 'menu' | 'footer' | 'toolbar';
 *   className?: string;
 *   children?: import('react').ReactNode;
 *   onClick?: () => void;
 * }} props
 */
export function FacebookFollowLink({
  location,
  variant = 'button',
  className = '',
  children,
  onClick,
}) {
  const label =
    typeof children === 'string' && children.trim() !== ''
      ? children.trim()
      : 'Follow on Facebook';

  function handleClick() {
    trackFacebookFollowClick(location);
    onClick?.();
  }

  return (
    <a
      className={`facebook-follow-link facebook-follow-link--${variant}${className ? ` ${className}` : ''}`}
      href={FACEBOOK_PAGE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      {variant !== 'text' && (
        <FacebookIcon size={variant === 'menu' || variant === 'toolbar' ? 16 : 18} />
      )}
      <span>{label}</span>
    </a>
  );
}
